import React, { useState } from "react";
import { TableRow, TableCell, Button } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import WhatsAppServices from "services/WhatsAppServices";
import { notifyError, notifySuccess } from "utils/toast";

const TemplateTable = ({
  templatedata,
  handleUpdate,
  handleDelete,
  handleModalOpen,
  hideDelete,
  hideEdit,
}) => {
  const [loadingId, setLoadingId] = useState(null);
  const [localData, setLocalData] = useState(templatedata || []);
  
  const handleCheckClick = async (id) => {
    try {
      setLoadingId(id);
      const res = await WhatsAppServices.checkTemplateStatus(id);

      if (res.success && res.data?.newStatus) {
        const updatedStatus = res.data.newStatus;

        // Update the status locally in the table
        setLocalData((prev) =>
          prev.map((t) => (t.id === id ? { ...t, status: updatedStatus } : t))
        );

        notifySuccess("Template status updated");
      } else {
        notifyError("Failed to update");
      }
    } catch (err) {
      console.error("Error checking template status:", err);
      notifyError("Error checking template status");
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <>
      {localData?.map((t, index) => (
        <TableRow key={t.id}>
          <TableCell className="text-center text-xs">{index + 1}</TableCell>
          <TableCell className="text-center text-xs">{t.name}</TableCell>
          <TableCell className="text-center text-xs">{t.category}</TableCell>
          <TableCell className="text-center text-xs">{t.language}</TableCell>

          <TableCell className="text-center text-xs">
            {t.status === "approved" && (
              <span className="text-green-600 font-semibold">Approved</span>
            )}
            {t.status === "pending" && (
              <span className="text-yellow-600 font-semibold">Pending</span>
            )}
            {t.status === "rejected" && (
              <span className="text-red-600 font-semibold">Rejected</span>
            )}
          </TableCell>

          <TableCell className="text-center">
            <div className="flex gap-1 justify-center items-center">
              <EditDeleteButton
                id={t.id}
                title={t.name}
                handleUpdate={handleUpdate}
                handleDelete={handleDelete}
                handleModalOpen={handleModalOpen}
                hideEdit={hideEdit}
                hideDelete={hideDelete}
              />

              <Button
                size="small"
                layout="outline"
                style={{
                  padding: "2px 6px",
                  minWidth: "auto",
                  width: "auto",
                  fontSize: "0.8rem",
                  lineHeight: "1",
                  height: "30px",
                }}
                onClick={() => handleCheckClick(t.id)}
                disabled={loadingId === t.id}
              >
                {loadingId === t.id ? "Checking..." : "Check"}
              </Button>
            </div>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default TemplateTable;
